import RainbowLink from '@otovo/shared/components/RainbowLink/RainbowLink';
import ArrowRightSvg from '@otovo/shared/images/icons/arrow-right.svg';
import cx from 'classnames';

type CTALinkProps = {
  href: string;
  children: React.ReactNode;
  className?: string;
};

const CTALink = ({ href, children, className }: CTALinkProps) => {
  return (
    <RainbowLink className={cx('text-subheading', className)} href={href}>
      {children}
      <ArrowRightSvg className="ml-2 inline-block size-3" />
    </RainbowLink>
  );
};

export default CTALink;
